// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminCertificateTemplateListItem extends Base {
  constructor(props, context) {
    super(props);
  }

  _goToItemShow(certificateTemplateId) {
    this.props.history.push(`/admin/certificate-templates/${certificateTemplateId}`);
  }

  render() {
    const { certificateTemplate } = this.props;
    return (
      <tr className="linkable" onClick={this._goToItemShow.bind(this, certificateTemplate._id)}>
        <td className="_40">{certificateTemplate.name}</td>
        <td className="_20 right">{moment(certificateTemplate.updated).format("MMMM Do YYYY, h:mm a")}</td>
      </tr>
    )
  }
}

AdminCertificateTemplateListItem.propTypes = {
  certificateTemplate: PropTypes.object.isRequired
}

export default withRouter(AdminCertificateTemplateListItem);



// WEBPACK FOOTER //
// modules/certificateTemplate/components/AdminCertificateTemplateListItem.js.jsx